/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ userName: NonNullable<unknown> }} Settings_Reportingapikeys_Deactivateall_Warning3Inputs */

const en_settings_reportingapikeys_deactivateall_warning3 = /** @type {(inputs: Settings_Reportingapikeys_Deactivateall_Warning3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This immediately deactivates all active API keys for ${i?.userName}. All of the client's integrations will stop working.`)
};

/**
* | output |
* | --- |
* | "This immediately deactivates all active API keys for {userName}. All of the client's integrations will stop working." |
*
* @param {Settings_Reportingapikeys_Deactivateall_Warning3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_deactivateall_warning3 = /** @type {((inputs: Settings_Reportingapikeys_Deactivateall_Warning3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Deactivateall_Warning3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_deactivateall_warning3(inputs)
});
export { settings_reportingapikeys_deactivateall_warning3 as "settings_reportingApiKeys_deactivateAll_warning" }